module.exports = __webpack_public_path__ + "img/media-178.be50d6a7.png";